import { Box, Container } from "@material-ui/core";
import { SGSCard } from "components";
import SGSDropZone from "components/SGSDropZone/SGSDropZone";
import { useDocumementAg2r } from "features/arretTravail/contexts/DocumentAg2rProvider";
import { useEffect } from "react";
import HistoryDocumentLidl from "../historyDocumentLidl/HistoryDocumentLidl";
import styles from './LidlDocument.module.scss';

const LidlDocument = (): JSX.Element => {
    const { getListHistoryDocumentAg2r } = useDocumementAg2r();

    useEffect(() => {
        getListHistoryDocumentAg2r();
    }, []);

    return (
        <Container maxWidth="xl">
            <SGSCard>
                <Box className={styles.titleBox}>Dépôt de fichier</Box>

                <Box className={styles.containerDropZone}>
                    <SGSDropZone 
                        label="Glissez-déposez ou choisissez un fichier à télécharger"
                        accept={[".csv", "text/csv"]}
                        width="40%"
                        height="100px"
                        reloadList={getListHistoryDocumentAg2r}
                    />
                </Box>

                <Box className={styles.titleBox}>Historique des dépôts de fichiers</Box>

                <HistoryDocumentLidl />
                
            </SGSCard>
        </Container>
    );
};

export default LidlDocument;